<template>
    <div class="page container" data-page="events">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/events">Events</router-link>
        </div>

        <div class="infoAlerts t-align-center m-bottom">
            <p class="info"><ion-icon name="information-circle"></ion-icon> 
                Due to COVID-19, some events might be changed or cancelled. We will notify you if such thing occur. Thank you.
            </p>
        </div>
        
        <h1>All Events</h1>

        <nav class="filters">

            <span class="link active">Upcoming Events</span>

            <!-- <a href="#0"
                class="link"
                :class="{active: type === 'latest'}"
                @click.prevent="toggleEventType('latest')"
            >Active</a>

            <a href="#0"
                class="link"
                :class="{active: type === 'past'}"
                @click.prevent="toggleEventType('past')"
            >Past</a>

            <a href="#0"
                class="link"
                :class="{active: type === 'userJoined'}"
                @click.prevent="toggleEventType('userJoined')"
                v-show="isLoggedIn"
            >Joined</a>

            <a href="#0"
                class="link"
                :class="{active: type === 'userSaved'}"
                @click.prevent="toggleEventType('userSaved')"
                v-show="isLoggedIn"
            >Saved</a> -->

            <!-- <a href="#0"
                class="link"
                :class="{active: type === 'private'}"
                @click.prevent="toggleEventType('private')"
                v-show="isLoggedIn"
            >Invited</a> -->
        </nav>

        <Events :key="`latest_events_${eventsKey}`" :grid="grid" :type="'latest'"></Events>

        <nav class="filters">
            <span class="link active">Past Events</span>
        </nav>

        <Events :key="`past_events_${eventsKey}`" :grid="grid" :type="'past'"></Events>

        <Membership></Membership>
    </div>
</template>

<script>
    import Events from '../components/Events.vue'
    import Membership from '../components/Membership.vue'

    export default {
        components: {
            Events,
            Membership
        },
        data(){
            return{
                grid: '4',
                type: 'latest',
                eventsKey: 0
            }
        },
        computed: {
            isLoggedIn(){
                let isMember = false
                if(this.$store.state.currentUser !== null){
                    if(this.$store.state.userProfile.isMember === true){
                        isMember = true
                    }
                }
                return isMember 
            }
        },
        methods: {
            toggleEventType(type){
                this.type = type
                this.eventsKey += 1
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Events.vue